import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/app/submit-company/page.tsx")